// The state of the services as a dot in the header, on every page: green when
// all are fine, orange when one is degraded, red when one is down or the
// backend cannot be reached, grey until the first answer. A click opens
// Überblick › Zustand, where the details are.

import { api } from "@/api/client";
import type { DepStatus } from "@/api/types";
import { usePoll } from "@/hooks/usePoll";
import { t, tOr } from "@/i18n";
import { currentView } from "@/state/filters";

export function HeaderStatus() {
  const health = usePoll((s) => api.health(s), []);
  const status: DepStatus = health.error ? "down" : (health.data?.status ?? "unknown");
  const label = t("header.status", { status: tOr(`status.${status}`, status) });
  return (
    <button
      type="button"
      class={`status-dot ${status}`}
      aria-label={label}
      title={label}
      onClick={() => (currentView.value = "health")}
    />
  );
}
